import {err, ok, ValidationError} from 'framework';
import type {Result, Validator} from 'framework';
import * as z from 'zod';
import {
  ASSISTANT_ATTACHMENT_ID_GLUE,
  ASSISTANT_ATTACHMENT_PREFIX,
} from '../../domain/assistant-attachment-id.value-object';
import type {SendMessageData} from '../../domain/send-message-data';
import {ASSISTANT_MESSAGE_MAX_LENGTH} from '../../lib/constants';
import {attachmentUploadConfig} from '../../lib/attachment-upload-config';

const attachmentIdSchema = z.templateLiteral([
  ASSISTANT_ATTACHMENT_PREFIX,
  ASSISTANT_ATTACHMENT_ID_GLUE,
  z.string().min(1),
]);

/** Text may be empty only when at least one photo travels with the message. */
export class SendMessageDataValidator implements Validator<SendMessageData> {
  readonly standardSchema = z
    .object({
      text: z.string().trim().max(ASSISTANT_MESSAGE_MAX_LENGTH),
      attachmentIds: z.array(attachmentIdSchema).max(attachmentUploadConfig.maxCount),
    })
    .strict()
    .refine(value => value.text.length > 0 || value.attachmentIds.length > 0, {
      message: 'Message is required.',
      path: ['text'],
    });

  validate(value: unknown): Result<SendMessageData, ValidationError> {
    const parsed = this.standardSchema.safeParse(value);
    if (!parsed.success) {
      return err(new ValidationError(parsed.error.issues[0]?.message ?? 'Invalid message.'));
    }
    return ok(parsed.data);
  }
}
